export default class OpenModal {
  constructor(context) {
    this.context = context;
  }

  run(modal) {
    this.context.stores.modal.set(modal);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/modal/open_modal.js